export enum RaAccountingStatus {
  ACCRUALS = 'ACCRUALS',
  ACCOUNTED = 'ACCOUNTED',
  PART_ACCOUNTED = 'PART_ACCOUNTED',
  NOT_ACCOUNTED = 'NOT_ACCOUNTED',
}
